import React from "react";
import "./Accordion.css";

const CustomAccordion = ({ testId, title, children }) => {
  const [isOpen, setOpen] = React.useState(true);
  return (
    <div data-testid={`accordion-${testId}`} className="accordion-wrapper">
      <div
        className={`accordion-title ${isOpen ? "open" : ""}`}
        onClick={() => setOpen(!isOpen)}
      >
        {title}
      </div>
      <div className={`accordion-item ${!isOpen ? "collapsed" : ""}`}>
        <div className="accordion-content">{children}</div>
      </div>
    </div>
  );
};

export default CustomAccordion;
